import React, { useEffect, useState, useRef } from 'react';
import '../styles/CantoConnect.css';
import '../styles/BannersDash.css';
import { FaPlusCircle, FaSearch } from 'react-icons/fa';
import axios from 'axios';
import config from '../../../constants/config';
import { RiCheckFill, RiCloseFill, RiFileShield2Line, RiToggleFill, RiToggleLine } from 'react-icons/ri';
import { useSlideout } from '../../../hooks/SlideoutContext';
import { IoMdRefresh } from 'react-icons/io';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export default function CantoConnectDash() {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const { openSlideout, closeSlideout } = useSlideout();
    
    useEffect(() => {
      fetchEvents();
    }, [])

    const fetchEvents = () => {
      setLoading(true);

      axios.post(config.api.url + 'admin/events/connect/fetch', {}, {
          crossdomain: true,
          headers: {
            'api': config.api.key,
            'auth': 'b8GjLbLHDX9isF10ptWj',
          }
      })
      .then((json) => {
        const { success, response, data } = json.data;

        if(success){
          setEvents(data);
          console.log(data);
        } else {
          console.log(response)
        }
        setLoading(false);
      })
      .catch(function (error) {
        console.error("Fetch error:", error);
        setLoading(false);
      });
    }
    
    const EditEvent = ({ event, fetchEvents }) => {
        const { closeSlideout } = useSlideout();
        const [eventData, setEventData] = useState({
            id: event.id,
            name: event.name,
            content: event.content || "",
            location: event.venue || "",
            date_from: event.date_from,
            date_to: event.date_to,
            active: event.active === 1,
            image: event.image,
            logo: event.logo || "",
            c2a: event.c2a || "",
            color: event.color || "#40B6BF",
            album_link: event.album_link || "",
            main_media: event.main_media || "",
            main_media_url: "",
            title: event.title || "",
            button_text: event.button_text || "Read more",
            c2a_secondary: event.c2a_secondary || "",
            button_text_secondary: event.button_text_secondary || ""
        });

        // Parse stats from JSON string or initialize empty array
        const [stats, setStats] = useState(() => {
            try {
                return event.stats ? JSON.parse(event.stats) : [];
            } catch (e) {
                return [];
            }
        });

        const [selectedImageFile, setSelectedImageFile] = useState(null);
        const [selectedImagePreview, setSelectedImagePreview] = useState(event.image);
        const fileInputRef = useRef(null);
        
        const [selectedLogoFile, setSelectedLogoFile] = useState(null);
        const [selectedLogoPreview, setSelectedLogoPreview] = useState(event.logo || "");
        const logoInputRef = useRef(null);

        const [selectedMainMediaFile, setSelectedMainMediaFile] = useState(null);
        const [selectedMainMediaPreview, setSelectedMainMediaPreview] = useState(event.main_media || "");
        const mainMediaInputRef = useRef(null);

        // Gallery images state
        const [galleryImages, setGalleryImages] = useState([]);
        const [uploadingGallery, setUploadingGallery] = useState(false);
        const galleryInputRef = useRef(null);

        // Fetch gallery images on mount
        useEffect(() => {
            fetchGalleryImages();
        }, []);

        const fetchGalleryImages = () => {
            const formData = new FormData();
            formData.append('event_id', event.id);

            axios.post(config.api.url + 'admin/events/images/fetch', formData, {
                crossdomain: true,
                headers: {
                    api: config.api.key,
                    auth: 'b8GjLbLHDX9isF10ptWj',
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then((json) => {
                const { success, data } = json.data;
                if (success) {
                    setGalleryImages(data || []);
                }
            })
            .catch((error) => {
                console.error('Fetch gallery error:', error);
            });
        };

        const handleGalleryImageAdd = (e) => {
            const file = e.target.files[0];
            if (!file) return;

            if (galleryImages.length >= 3) {
                alert('Maximum of 3 gallery images allowed');
                return;
            }

            setUploadingGallery(true);
            const formData = new FormData();
            formData.append('event_id', event.id);
            formData.append('image', file);

            axios.post(config.api.url + 'admin/events/images/add', formData, {
                crossdomain: true,
                headers: {
                    api: config.api.key,
                    auth: 'b8GjLbLHDX9isF10ptWj',
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then((json) => {
                const { success, response } = json.data;
                if (success) {
                    fetchGalleryImages();
                } else {
                    alert(response);
                }
                setUploadingGallery(false);
            })
            .catch((error) => {
                console.error('Upload gallery error:', error);
                setUploadingGallery(false);
            });
        };

        const handleGalleryImageDelete = (imageId) => {
            if (!window.confirm('Are you sure you want to delete this image?')) return;

            const formData = new FormData();
            formData.append('image_id', imageId);

            axios.post(config.api.url + 'admin/events/images/delete', formData, {
                crossdomain: true,
                headers: {
                    api: config.api.key,
                    auth: 'b8GjLbLHDX9isF10ptWj',
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then((json) => {
                const { success } = json.data;
                if (success) {
                    fetchGalleryImages();
                }
            })
            .catch((error) => {
                console.error('Delete gallery error:', error);
            });
        };

        // Handle input changes
        const handleChange = (e) => {
            const { name, value, type, checked } = e.target;
            setEventData((prev) => ({
                ...prev,
                [name]: type === "checkbox" ? checked : value
            }));
        };

        // Handle file selection
        const handleImageChange = (event) => {
            const file = event.target.files[0];
            if (file) {
                const imageUrl = URL.createObjectURL(file); // Create a temporary preview
                setSelectedImageFile(file);
                setSelectedImagePreview(imageUrl);
            }
        };

        // Open file input
        const handleSelectImage = () => {
            fileInputRef.current.click();
        };
        
        // Handle logo file selection
        const handleLogoChange = (event) => {
            const file = event.target.files[0];
            if (file) {
                const logoUrl = URL.createObjectURL(file);
                setSelectedLogoFile(file);
                setSelectedLogoPreview(logoUrl);
            }
        };

        // Open logo file input
        const handleSelectLogo = () => {
            logoInputRef.current.click();
        };

        // Handle main media file selection
        const handleMainMediaChange = (event) => {
            const file = event.target.files[0];
            if (file) {
                const mediaUrl = URL.createObjectURL(file);
                setSelectedMainMediaFile(file);
                setSelectedMainMediaPreview(mediaUrl);
            }
        };

        // Open main media file input
        const handleSelectMainMedia = () => {
            mainMediaInputRef.current.click();
        };

        // Handle save changes
        const handleSaveChanges = () => {
            const formData = new FormData();
            const isNewEvent = !eventData.id;
            
            if (!isNewEvent) {
                formData.append("id", eventData.id);
            }
            
            formData.append("name", eventData.name);
            formData.append("content", eventData.content);
            formData.append("location", eventData.location);
            formData.append("date_from", eventData.date_from);
            formData.append("date_to", eventData.date_to);
            formData.append("active", eventData.active ? 1 : 0);
            
            // Convert date_from to Unix timestamp for the event calendar
            if (eventData.date_from) {
                const timestamp = Math.floor(new Date(eventData.date_from).getTime() / 1000);
                formData.append("timestamp", timestamp);
            }
            formData.append("c2a", eventData.c2a);
            formData.append("stats", JSON.stringify(stats));
            formData.append("color", eventData.color);
            formData.append("album_link", eventData.album_link);
            formData.append("title", eventData.title);
            formData.append("button_text", eventData.button_text);
            formData.append("c2a_secondary", eventData.c2a_secondary);
            formData.append("button_text_secondary", eventData.button_text_secondary);
            formData.append("main_media_url", eventData.main_media_url);

            if (selectedImageFile) {
                formData.append("image", selectedImageFile);
            }
            
            if (selectedLogoFile) {
                formData.append("logo", selectedLogoFile);
            }

            if (selectedMainMediaFile) {
                formData.append("main_media", selectedMainMediaFile);
            }

            const endpoint = isNewEvent 
                ? "admin/events/connect/add" 
                : "admin/events/connect/update";

            axios.post(config.api.url + endpoint, formData, {
                crossdomain: true,
                headers: {
                    api: config.api.key,
                    auth: "b8GjLbLHDX9isF10ptWj",
                    "Content-Type": "multipart/form-data"
                }
            })
            .then((json) => {
                const { success, response } = json.data;
                if (success) {
                    closeSlideout();
                    fetchEvents();
                } else {
                    console.log("Error:", response);
                }
            })
            .catch((error) => {
                console.error(isNewEvent ? "Create error:" : "Update error:", error);
            });
        };

        return (
            <div className="EditBannerContainer">
                <div className="EditBannerOptions">
                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Event Image</div>
                        <div className="EditBannerOptionContent">
                            <div 
                                className="EditBannerImagePreview" 
                                style={{ backgroundImage: `url(${selectedImagePreview})` }}
                                onClick={handleSelectImage}
                            ></div>
                            <input 
                                type="file" 
                                ref={fileInputRef} 
                                style={{ display: 'none' }} 
                                onChange={handleImageChange} 
                                accept="image/*"
                            />
                            <div className="EditBannerImageText">Click to change image</div>
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Event Logo</div>
                        <div className="EditBannerOptionContent">
                            <div 
                                className="EditBannerImagePreview" 
                                style={{ backgroundImage: `url(${selectedLogoPreview})` }}
                                onClick={handleSelectLogo}
                            >
                                {!selectedLogoPreview && <span>Click to select logo</span>}
                            </div>
                            <input 
                                type="file" 
                                ref={logoInputRef} 
                                onChange={handleLogoChange} 
                                style={{ display: 'none' }} 
                                accept="image/*"
                            />
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Main Media (Video or Image)</div>
                        <div className="EditBannerOptionContent">
                            {selectedMainMediaPreview && (
                                <div style={{ marginBottom: '10px' }}>
                                    {selectedMainMediaFile?.type?.startsWith('video/') || selectedMainMediaPreview.match(/\.(mp4|webm|ogg)$/i) ? (
                                        <video 
                                            src={selectedMainMediaPreview} 
                                            controls 
                                            style={{ width: '100%', maxHeight: '300px', borderRadius: '4px' }}
                                        />
                                    ) : (
                                        <div 
                                            className="EditBannerImagePreview" 
                                            style={{ backgroundImage: `url(${selectedMainMediaPreview})`, height: '200px' }}
                                        />
                                    )}
                                </div>
                            )}
                            <button
                                type="button"
                                onClick={handleSelectMainMedia}
                                style={{
                                    padding: '10px 15px',
                                    backgroundColor: '#0066cc',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    width: '100%',
                                    marginBottom: '10px'
                                }}
                            >
                                {selectedMainMediaPreview ? 'Change Main Media' : 'Select Main Media'}
                            </button>
                            <input 
                                type="file" 
                                ref={mainMediaInputRef} 
                                onChange={handleMainMediaChange} 
                                style={{ display: 'none' }} 
                                accept="video/*,image/*"
                            />
                            <div style={{ margin: '10px 0', textAlign: 'center', color: '#666' }}>OR</div>
                            <input 
                                type="url" 
                                name="main_media_url" 
                                value={eventData.main_media_url} 
                                onChange={handleChange} 
                                className="EditBannerInput"
                                placeholder="https://www.youtube.com/watch?v=..."
                            />
                            <small style={{ color: '#666', fontSize: '12px', marginTop: '5px', display: 'block' }}>
                                Upload a file OR paste a YouTube URL (YouTube URL takes priority)
                            </small>
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Event Name</div>
                        <div className="EditBannerOptionContent">
                            <input 
                                type="text" 
                                name="name" 
                                value={eventData.name} 
                                onChange={handleChange} 
                                className="EditBannerInput"
                            />
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Event Title</div>
                        <div className="EditBannerOptionContent">
                            <input 
                                type="text" 
                                name="title" 
                                value={eventData.title} 
                                onChange={handleChange} 
                                className="EditBannerInput"
                                placeholder="Optional subtitle/title for the event"
                            />
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Content</div>
                        <div className="EditBannerOptionContent">
                            <ReactQuill
                                theme="snow"
                                value={eventData.content}
                                onChange={(content) => {
                                    setEventData(prev => ({
                                        ...prev,
                                        content: content
                                    }));
                                }}
                                modules={{
                                    toolbar: [
                                        ['bold', 'italic', 'underline', 'strike'],
                                        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                                        ['link'],
                                        ['clean']
                                    ],
                                }}
                                placeholder="Enter event content"
                                className="EventContentEditor"
                                style={{ minHeight: '200px' }}
                            />
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Location</div>
                        <div className="EditBannerOptionContent">
                            <input 
                                type="text" 
                                name="location" 
                                value={eventData.location} 
                                onChange={handleChange} 
                                className="EditBannerInput"
                            />
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Call to Action Link</div>
                        <div className="EditBannerOptionContent">
                            <input 
                                type="url" 
                                name="c2a" 
                                value={eventData.c2a} 
                                onChange={handleChange} 
                                className="EditBannerInput"
                                placeholder="https://example.com/register"
                            />
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Button Text</div>
                        <div className="EditBannerOptionContent">
                            <input 
                                type="text" 
                                name="button_text" 
                                value={eventData.button_text} 
                                onChange={handleChange} 
                                className="EditBannerInput"
                                placeholder="Read more"
                            />
                            <small style={{ color: '#666', fontSize: '12px', marginTop: '5px', display: 'block' }}>
                                Text displayed on the primary call-to-action button
                            </small>
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Secondary Button Link</div>
                        <div className="EditBannerOptionContent">
                            <input 
                                type="url" 
                                name="c2a_secondary" 
                                value={eventData.c2a_secondary} 
                                onChange={handleChange} 
                                className="EditBannerInput"
                                placeholder="https://example.com/more-info"
                            />
                            <small style={{ color: '#666', fontSize: '12px', marginTop: '5px', display: 'block' }}>
                                Optional second button URL
                            </small>
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Secondary Button Text</div>
                        <div className="EditBannerOptionContent">
                            <input 
                                type="text" 
                                name="button_text_secondary" 
                                value={eventData.button_text_secondary} 
                                onChange={handleChange} 
                                className="EditBannerInput"
                                placeholder="Learn More"
                            />
                            <small style={{ color: '#666', fontSize: '12px', marginTop: '5px', display: 'block' }}>
                                Text displayed on the secondary button
                            </small>
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Photo Album Link</div>
                        <div className="EditBannerOptionContent">
                            <input 
                                type="url" 
                                name="album_link" 
                                value={eventData.album_link} 
                                onChange={handleChange} 
                                className="EditBannerInput"
                                placeholder="https://photos.example.com/album"
                            />
                            <small style={{ color: '#666', fontSize: '12px', marginTop: '5px', display: 'block' }}>
                                Link to the full photo album for this event
                            </small>
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Event Color</div>
                        <div className="EditBannerOptionContent">
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <input 
                                    type="color" 
                                    name="color" 
                                    value={eventData.color} 
                                    onChange={handleChange} 
                                    style={{
                                        width: '60px',
                                        height: '40px',
                                        border: '1px solid #ddd',
                                        borderRadius: '4px',
                                        cursor: 'pointer'
                                    }}
                                />
                                <input 
                                    type="text" 
                                    name="color" 
                                    value={eventData.color} 
                                    onChange={handleChange} 
                                    className="EditBannerInput"
                                    placeholder="#40B6BF"
                                    pattern="^#[0-9A-Fa-f]{6}$"
                                    style={{ flex: 1 }}
                                />
                            </div>
                            <small style={{ color: '#666', fontSize: '12px', marginTop: '5px', display: 'block' }}>
                                This color will be used for buttons and stats background
                            </small>
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Event Stats (Max 4)</div>
                        <div className="EditBannerOptionContent">
                            {stats.map((stat, index) => (
                                <div key={index} style={{ marginBottom: '15px', padding: '10px', border: '1px solid #ddd', borderRadius: '4px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                        <strong>Stat {index + 1}</strong>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                const newStats = stats.filter((_, i) => i !== index);
                                                setStats(newStats);
                                            }}
                                            style={{
                                                background: '#ff4444',
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '4px',
                                                padding: '5px 10px',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            Remove
                                        </button>
                                    </div>
                                    <input
                                        type="text"
                                        placeholder="Number (e.g., 4, 30+, 600+)"
                                        value={stat.number || ''}
                                        onChange={(e) => {
                                            const newStats = [...stats];
                                            newStats[index].number = e.target.value;
                                            setStats(newStats);
                                        }}
                                        className="EditBannerInput"
                                        style={{ marginBottom: '8px' }}
                                    />
                                    <input
                                        type="text"
                                        placeholder="Label (e.g., Day Flagship, Speakers)"
                                        value={stat.label || ''}
                                        onChange={(e) => {
                                            const newStats = [...stats];
                                            newStats[index].label = e.target.value;
                                            setStats(newStats);
                                        }}
                                        className="EditBannerInput"
                                    />
                                </div>
                            ))}
                            {stats.length < 4 && (
                                <button
                                    type="button"
                                    onClick={() => {
                                        if (stats.length < 4) {
                                            setStats([...stats, { number: '', label: '' }]);
                                        }
                                    }}
                                    style={{
                                        padding: '10px 15px',
                                        backgroundColor: '#0066cc',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        width: '100%'
                                    }}
                                >
                                    Add Stat
                                </button>
                            )}
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Date From</div>
                        <div className="EditBannerOptionContent">
                            <input 
                                type="date" 
                                name="date_from" 
                                value={eventData.date_from} 
                                onChange={handleChange} 
                                className="EditBannerInput"
                            />
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Date To</div>
                        <div className="EditBannerOptionContent">
                            <input 
                                type="date" 
                                name="date_to" 
                                value={eventData.date_to} 
                                onChange={handleChange} 
                                className="EditBannerInput"
                            />
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Gallery Images (Max 3)</div>
                        <div className="EditBannerOptionContent">
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '10px' }}>
                                {galleryImages.map((img) => (
                                    <div key={img.id} style={{ position: 'relative', width: '150px', height: '150px' }}>
                                        <div 
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                backgroundImage: `url(${img.image})`,
                                                backgroundSize: 'cover',
                                                backgroundPosition: 'center',
                                                borderRadius: '4px'
                                            }}
                                        />
                                        <button
                                            onClick={() => handleGalleryImageDelete(img.id)}
                                            style={{
                                                position: 'absolute',
                                                top: '5px',
                                                right: '5px',
                                                background: 'rgba(255, 0, 0, 0.8)',
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '50%',
                                                width: '25px',
                                                height: '25px',
                                                cursor: 'pointer',
                                                fontSize: '16px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                        >
                                            ×
                                        </button>
                                    </div>
                                ))}
                            </div>
                            {galleryImages.length < 3 && (
                                <>
                                    <input
                                        type="file"
                                        ref={galleryInputRef}
                                        onChange={handleGalleryImageAdd}
                                        style={{ display: 'none' }}
                                        accept="image/*"
                                    />
                                    <button
                                        type="button"
                                        onClick={() => galleryInputRef.current.click()}
                                        disabled={uploadingGallery}
                                        style={{
                                            padding: '10px 15px',
                                            backgroundColor: uploadingGallery ? '#ccc' : '#0066cc',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '4px',
                                            cursor: uploadingGallery ? 'not-allowed' : 'pointer'
                                        }}
                                    >
                                        {uploadingGallery ? 'Uploading...' : 'Add Gallery Image'}
                                    </button>
                                </>
                            )}
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Active</div>
                        <div className="EditBannerOptionContent">
                            <label className="EditBannerCheckboxLabel">
                                <input 
                                    type="checkbox" 
                                    name="active" 
                                    checked={eventData.active} 
                                    onChange={handleChange} 
                                    className="EditBannerCheckbox"
                                />
                                <span>Show on website</span>
                            </label>
                        </div>
                    </div>

                    <div className="EditBannerActions">
                        <button 
                            className="EditBannerSaveButton" 
                            onClick={handleSaveChanges}
                        >
                            Save Changes
                        </button>
                    </div>
                </div>
            </div>
        );
    };

  return (
    <div className='BannersDash'>
      <div className='BannersHeader'>
        <div className='BannersHeaderTitle'>
          <h1>CANTO Connect Events</h1>
          <p>Manage CANTO Connect events that appear on your website</p>
        </div>
        <div className='BannersHeaderActions'>
          <button className='BannersRefreshButton' onClick={fetchEvents}>
            <IoMdRefresh />
            <span>Refresh</span>
          </button>
          <button 
            className='BannersAddButton'
            onClick={() => {
              openSlideout({
                title: 'Add New Event',
                content: <EditEvent 
                  event={{
                    id: null,
                    name: '',
                    content: '',
                    venue: '',
                    date_from: '',
                    date_to: '',
                    active: 1,
                    image: '',
                    logo: '',
                    c2a: '',
                    stats: '',
                    color: '#40B6BF',
                    album_link: '',
                    main_media: '',
                    title: '',
                    button_text: 'Read more'
                  }} 
                  fetchEvents={fetchEvents}
                />
              });
            }}
          >
            <FaPlusCircle />
            <span>Add New</span>
          </button>
        </div>
      </div>

      <div className='BannersContent'>
        <div className='BannersContentNavigation'>
          <div className='BannersContentNavigationItem Active'>Active</div>
          <div className='BannersContentNavigationItem Image'>Image</div>
          <div className='BannersContentNavigationItem Title'>Title</div>
          <div className='BannersContentNavigationItem Subtitle'>Date From</div>
          <div className='BannersContentNavigationItem Subtitle'>Date To</div>
        </div>
        <div className='BannersScroll'>
          {events.map((event, index) => {
            return (
              <div className='BannerItem' key={event.id}>
                <div className="BannerItemDetailsText First Active">
                  <span className={`BannerItemDetailsTextOption Circle ${event.active ? 'Success' : 'Error'}`}>
                    {event.active
                      ? <RiCheckFill style={{ fontSize: 12 }} />
                      : <RiCloseFill style={{ fontSize: 12 }} />
                    }
                  </span>
                </div>
                <div className="BannerItemDetailsText Image">
                  <div 
                    className="BannerItemDetailsTextImage" 
                    style={{ backgroundImage: `url(${event.image})` }} 
                  />
                </div>
                <div className="BannerItemDetailsText Title Bold">{event.name}</div>
                <div className="BannerItemDetailsText Subtitle">{event.date_from}</div>
                <div className="BannerItemDetailsText Subtitle">{event.date_to}</div>

                <div className="BannerItemOptions">
                  <a 
                    onClick={() => {
                      const newStatus = event.active ? 0 : 1;
                      const formData = new FormData();
                      formData.append('id', event.id);
                      formData.append('status', newStatus);
                      
                      axios.post(config.api.url + 'admin/events/connect/toggle', formData, {
                        crossdomain: true,
                        headers: {
                          'api': config.api.key,
                          'auth': 'b8GjLbLHDX9isF10ptWj',
                          'Content-Type': 'multipart/form-data'
                        }
                      })
                      .then((json) => {
                        const { success, response } = json.data;
                        if (success) {
                          fetchEvents();
                        } else {
                          console.log('Error:', response);
                        }
                      })
                      .catch((error) => {
                        console.error('Toggle error:', error);
                      });
                    }} 
                    className={`BannerItemOptionsButton ${event.active ? 'DeleteInverted' : 'AddInverted'}`}
                  >
                    {event.active
                      ? <RiToggleFill style={{ fontSize: 14 }} />
                      : <RiToggleLine style={{ fontSize: 14 }} />
                    }
                    <span className="BannerItemOptionsButtonText">
                      {event.active ? 'Deactivate' : 'Activate'}
                    </span>
                  </a>

                  <a 
                    onClick={() => {
                      openSlideout({
                        title: 'Edit Event',
                        content: <EditEvent event={event} fetchEvents={fetchEvents}/>
                      });
                    }} 
                    className="BannerItemOptionsButton Edit"
                  >
                    <RiFileShield2Line style={{ fontSize: 14 }} />
                    <span className="BannerItemOptionsButtonText">Edit</span>
                  </a>

                  <a 
                    onClick={() => {
                      if (window.confirm(`Are you sure you want to delete "${event.name}"? This action cannot be undone.`)) {
                        const formData = new FormData();
                        formData.append('id', event.id);
                        
                        axios.post(config.api.url + 'admin/events/connect/delete', formData, {
                          crossdomain: true,
                          headers: {
                            'api': config.api.key,
                            'auth': 'b8GjLbLHDX9isF10ptWj',
                            'Content-Type': 'multipart/form-data'
                          }
                        })
                        .then((json) => {
                          const { success, response } = json.data;
                          if (success) {
                            fetchEvents();
                          } else {
                            console.log('Error:', response);
                            alert('Failed to delete event: ' + response);
                          }
                        })
                        .catch((error) => {
                          console.error('Delete error:', error);
                          alert('Error deleting event: ' + error.message);
                        });
                      }
                    }} 
                    className="BannerItemOptionsButton Delete"
                  >
                    <RiCloseFill style={{ fontSize: 14 }} />
                    <span className="BannerItemOptionsButtonText">Delete</span>
                  </a>
                </div>
              </div>
            );
          })}
        </div>
        <div className='BannersPaginationWrapper'>
          {/* Pagination will be added here when needed */}
        </div>
      </div>
    </div>
  )
}
